import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { withStyles } from '@material-ui/core/styles'

import LineChartView from '../charts/LineChartView'
import { timeseriesConfig } from '../../utils/TimeseriesConfig'

class UnitChartView extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    events: PropTypes.array.isRequired,
    timeseries: PropTypes.object.isRequired,
  }

  static styles = () => ({
  })

  render() {
    const { events, timeseries } = this.props
    const tsConfig = timeseriesConfig(timeseries.name)

    const data = []
    const dataMin = []
    const dataMax = []
    for (let x = 0; x < events.length; x += 1) {
      data.push({
        x: moment(events[x].timestamp),
        y: events[x].avg,
      })
      dataMin.push({
        x: moment(events[x].timestamp),
        y: events[x].min,
      })
      dataMax.push({
        x: moment(events[x].timestamp),
        y: events[x].max,
      })
    }

    if (data.length > 0) {
      return (
        <LineChartView
          data={data}
          dataMin={dataMin}
          dataMax={dataMax}
          label={timeseries.title}
          formatter={(v) => tsConfig.format(v, tsConfig.convert)}
          {...tsConfig.chart}
          {...this.props}
        />
      )
    }
    return null
  }
}

export default withStyles(UnitChartView.styles)(UnitChartView)
